import { FC } from 'react';
import { MassPostSaleJobs } from 'components/MassPostSaleJobs';
import { Page } from 'layouts/Page';
import { ENavigateNames } from 'routes/constants';

export const MassPostSaleJobsPage: FC = () => {
	return (
		<Page title={`${ENavigateNames.MASS_POST_SALE_JOBS} – EAS Control Center`}>
			<MassPostSaleJobs />
		</Page>
	);
};
